// eslint-disable-next-line
export default new (class ActivitiesModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.title = data.activity || [];
    model.slug = data.Slug || "";
    model.tag = data.tag || [];

    model.image = data.image?.image || [];
    model.content = data.detail || [];
    model.body = data.content || [];
    model.date = data.event || [];
    model.order = data.order || 0;

    return model;
  }
})();
